// Mock data for Typeit 4U landing page

export const heroData = {
  tagline: "India's AI Keyboard.\nType Less. Do More.",
  subtitle: "AI-powered keyboard built for Indians. Auto reply, translate Tamil & Hindi, generate captions, OCR, and 15 more features — all inside your keyboard. Works in every app.",
  playStoreUrl: "https://play.google.com/store/apps/details?id=com.typeit4u.keyboard",
  privacyNote: "Zero permissions — We never read your messages or notifications",
  stats: {
    downloads: "50,000+",
    rating: "4.6",
    users: "Built for Indian Users"
  }
};

export const trustBadges = [
  {
    id: 1,
    icon: "Shield",
    title: "Privacy First",
    description: "We never read your messages or notifications. Ever."
  },
  {
    id: 2,
    icon: "Flag",
    title: "Made for India",
    description: "Built for Tamil, Hindi & English speakers."
  },
  {
    id: 3,
    icon: "Zap",
    title: "Works Everywhere",
    description: "WhatsApp, Instagram, Gmail, and every other app."
  },
  {
    id: 4,
    icon: "Gift",
    title: "Free to Download",
    description: "Core features free. No credit card needed."
  }
];

export const aiFeatures = [
  {
    id: 1,
    title: "Answer AI Mode",
    description: "Get instant AI-powered answers to any question right from your keyboard. Research, learn, and get information without switching apps. Your personal AI assistant at your fingertips.",
    icon: "Brain",
    isNew: true
  },
  {
    id: 2,
    title: "AI Auto Reply",
    description: "Paste any message into the keyboard — instantly get 3 smart AI reply suggestions. Tap one to send. Works in WhatsApp, Instagram DMs, SMS, and every chat app.",
    icon: "MessageSquare"
  },
  {
    id: 3,
    title: "Translate to 22 Languages",
    description: "Translate English to any of India's 22 official languages including Tamil, Hindi, Telugu, Kannada, Malayalam, Bengali, Marathi, Gujarati, and more. Type in your language — get fluent translations instantly.",
    icon: "Languages",
    isNew: true
  },
  {
    id: 4,
    title: "Rephrase & Improve",
    description: "Make any message sound more professional, clear, or friendly in seconds. Perfect for work emails, business messages, and formal communication.",
    icon: "Wand2"
  },
  {
    id: 5,
    title: "OCR — Copy Text from Images",
    description: "Point your camera at any image, visiting card, document, menu, or printed text — extract and copy the text instantly. 100% offline using Google ML Kit.",
    icon: "ScanText"
  },
  {
    id: 6,
    title: "Social Media Content Creator",
    description: "Generate Instagram captions, post titles, descriptions, and hashtags — all inside your keyboard. Never stare at a blank caption box again.",
    icon: "Share2"
  },
  {
    id: 7,
    title: "Business Ready",
    description: "Generate festival greetings for Diwali, Holi, Eid, Pongal and more. Plus professional reply templates for business communication — all in seconds.",
    icon: "Briefcase"
  }
];

export const howItWorks = [
  {
    id: 1,
    step: "Step 1",
    icon: "Keyboard",
    title: "Open any app and tap the text field",
    description: "Typeit4u keyboard loads — ready with AI tools."
  },
  {
    id: 2,
    step: "Step 2",
    icon: "ClipboardPaste",
    title: "Paste the message or text you want AI to help with",
    description: "AI reads only what YOU paste. Nothing else. Ever."
  },
  {
    id: 3,
    step: "Step 3",
    icon: "Sparkles",
    title: "Tap the feature you need",
    description: "Reply, Translate, Improve, Caption — AI processes your text and returns the result instantly."
  },
  {
    id: 4,
    step: "Step 4",
    icon: "CheckCircle",
    title: "Review and insert",
    description: "Review the result and tap to insert it into your text field. Done. Your message is ready to send."
  }
];

export const powerFeatures = [
  {
    id: 1,
    title: "One-Click OCR Reader",
    description: "Instantly extract text from visiting cards, documents, or any printed material. 100% offline processing with Google ML Kit.",
    icon: "ScanText",
    isNew: true
  },
  {
    id: 2,
    title: "Single Click Attach Documents",
    description: "Quickly attach PDFs, images, or any files from your device directly into your chats. Seamless file sharing made easy.",
    icon: "Paperclip",
    isNew: true
  },
  {
    id: 3,
    title: "Single Click Live Location",
    description: "Share your real-time GPS location with a single tap. Generates a map link instantly without leaving the app.",
    icon: "MapPin",
    isNew: true
  },
  {
    id: 4,
    title: "Shortcut Actions",
    description: "Create custom shortcuts to insert long, frequently used text instantly. Type 'brb' and your full message appears. Saves 10+ minutes daily.",
    icon: "Zap"
  },
  {
    id: 5,
    title: "Built-in Clipboard",
    description: "Access your clipboard history and pinned snippets without leaving the app. Never lose important copied text again.",
    icon: "Clipboard"
  },
  {
    id: 6,
    title: "Reel Caption Generator",
    description: "Generate perfect Instagram Reel captions with relevant hashtags in one tap. Spend less time on captions, more time creating.",
    icon: "Film"
  },
  {
    id: 7,
    title: "AI Email Reply",
    description: "Paste any email you received — get a professional, context-aware reply ready to send. Works for business and personal emails.",
    icon: "Mail"
  },
  {
    id: 8,
    title: "Bullet Formatting",
    description: "Format your messages with clean bullet points for clear, structured communication — useful for work updates and lists.",
    icon: "List"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Free Plan",
    price: 0,
    period: "forever",
    features: [
      "15 AI requests per day",
      "AI Rewrite & Improve (basic)",
      "Translate Tamil & Hindi to English",
      "OCR Reader (5 scans per day)",
      "Festival post templates (basic)",
      "One-click live location",
      "Clipboard panel",
      "Community support"
    ],
    limitations: [],
    cta: "Get Started — Free",
    ctaUrl: "https://play.google.com/store/apps/details?id=com.typeit4u.keyboard",
    popular: false
  },
  {
    id: 2,
    name: "Pro Plan",
    price: 99,
    annualPrice: 999,
    period: "month",
    annualPeriod: "year",
    features: [
      "Unlimited AI requests (no daily limit)",
      "All translation languages unlocked",
      "Unlimited OCR scans",
      "Unlimited festival post templates",
      "Instagram caption + hashtag generator (unlimited)",
      "Reel caption generator (unlimited)",
      "AI email reply (unlimited)",
      "Advanced clipboard history (last 100 items)",
      "Custom shortcut actions (unlimited)",
      "Priority customer support",
      "All future features included",
      "No ads"
    ],
    savings: "Save 20%",
    cta: "Start Free Trial",
    ctaUrl: "https://play.google.com/store/apps/details?id=com.typeit4u.keyboard",
    popular: true
  }
];

export const socialProof = {
  builtFor: "Built for Indian Users",
  compatibility: "Works in WhatsApp, Instagram, and Gmail",
  testimonials: [
    {
      id: 1,
      text: "Typeit 4U transformed how I communicate with clients. The AI features save me hours every week!",
      author: "Priya Sharma",
      role: "Freelance Writer"
    },
    {
      id: 2,
      text: "The shortcut actions are a game-changer for my business. I can respond to customers instantly.",
      author: "Rahul Verma",
      role: "Business Owner"
    },
    {
      id: 3,
      text: "Finally, a keyboard that understands Indian English! The translation feature is spot-on.",
      author: "Anjali Patel",
      role: "Social Media Manager"
    }
  ]
};

export const footerLinks = {
  company: [
    { name: "About Us", href: "/about" },
    { name: "Contact Us", href: "/contact" },
    { name: "Features", href: "/features" },
    { name: "Blog", href: "/blog" }
  ],
  legal: [
    { name: "Privacy Policy", href: "/privacy", highlight: "No Keystroke Logging" },
    { name: "Terms & Conditions", href: "/terms" }
  ],
  support: [
    { name: "Help Center", href: "/help" },
    { name: "FAQ", href: "/faq" },
    { name: "Downloads", href: "https://play.google.com/store/apps/details?id=com.typeit4u.keyboard" }
  ],
  resources: [
    { name: "Feature Guides", href: "/feature" },
    { name: "Compare Keyboards", href: "/compare" },
    { name: "For Students", href: "/use-case/typeit4u-for-students" },
    { name: "For Business", href: "/use-case/typeit4u-for-business" },
    { name: "For Tamil Users", href: "/use-case/typeit4u-for-tamil-users" }
  ]
};
